import React, { useState } from "react";
import Contact from "../contact";
import Testimonials from "../Testimonials";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import permanentIcon from "../../images/individual/permanent-resident.svg";
import visaImage from "../../images/individual/FamilyVisaOption.jpg";
import helpIcon from "../../images/individual/helpIcon.svg";
import helpImage from "../../images/individual/immigetHelp.png";
import { FaPlus, FaTimes, FaCheckCircle, FaClock, FaGlobe, FaBriefcase, FaGraduationCap, FaPassport, FaDollarSign, FaUserCheck, FaCalendarAlt, FaMapMarkedAlt, FaFileAlt, FaUsers, FaHeart } from "react-icons/fa";
import unlimitedIcon from "../../images/individual/ic_outline-home-work.svg";
import iconPeople from "../../images/individual/akar-icons_people-group.svg";
import materialIcon from "../../images/individual/material-symbols_family-home-outline.svg";
import medicareIcon from "../../images/individual/icon-park-outline_medical-files.svg";
import { Helmet } from "react-helmet-async";

const WorkingHolidayVisa = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const testimonials = [
    {
      name: "Sarah, UK",
      content: "Thanks to Immiget Global, I got my WHV approved in just 4 weeks! Now I'm working in Melbourne and loving it!",
      rating: 5
    }
  ];

  const faqs = [
    {
      question: "Can I bring my family on a Working Holiday Visa?",
      answer: "No, this visa is for individuals only."
    },
    {
      question: "Can I apply for permanent residency after a WHV?",
      answer: "While the WHV itself doesn't lead to PR, it can help you gain skills for other visas."
    },
    {
      question: "What jobs can I do on a WHV?",
      answer: "Most short-term jobs are allowed, but restrictions apply in some industries."
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Working Holiday Visa Australia (Subclass 417 & 462) - Travel & Work - Immiget Global</title>
        <meta name="description" content="Working Holiday Visa Australia - Live, work & travel in Australia for up to 3 years. Expert guidance for Subclass 417 & 462 visas. High success rate applications." />
        <meta name="keywords" content="working holiday visa australia, subclass 417, subclass 462, work and travel australia, WHV, youth visa australia" />
      </Helmet>

      {/* Hero Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex max-xl:flex-col justify-between max-xl:gap-6 xl:gap-[80px] xl:items-center">
          <div className="xl:w-[50%]">
            <h1 className="xl:text-[28px] text-[24px] max-xl:text-center text-blue mt-6 font-semibold hellix-font">
              Working Holiday Visa Australia (Subclass 417 & 462) – Travel & Work in Australia
            </h1>
            <p className="max-xl:text-center hellix-font text-blue text-lg xl:text-[20px] font-normal">
              Dreaming of exploring Australia while earning money? The Working Holiday Visa (Subclass 417 & 462) allows young adults from eligible countries to live, work, and travel in Australia for up to 1-3 years. At Immiget Global, we help you navigate the visa process smoothly so you can embark on your Australian adventure with confidence.
            </p>
          </div>
          <div className="xl:w-[50%] max-xl:justify-center max-xl:flex max-xl:mt-4">
            <img src={visaImage} alt="Working Holiday Visa" />
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* What is a Working Holiday Visa */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            What is a Working Holiday Visa?
          </h1>
        </div>

        <div className="mt-8">
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <p className="text-blue text-lg hellix-font mb-6">
              The Working Holiday Visa (WHV) is a temporary visa that allows young travelers (aged 18-35) to:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
              {[
                { icon: FaBriefcase, text: "Work in Australia to fund their travels" },
                { icon: FaGraduationCap, text: "Study for short courses (up to 4 months)" },
                { icon: FaGlobe, text: "Explore Australia for up to 12 months (with options to extend)" }
              ].map((benefit, index) => {
                const IconComponent = benefit.icon;
                return (
                  <div key={index} className="flex items-start gap-3 p-4 bg-blue-50 rounded-lg">
                    <FaCheckCircle className="text-green-500 text-lg mt-1 flex-shrink-0" />
                    <span className="text-blue hellix-font">{benefit.text}</span>
                  </div>
                );
              })}
            </div>

            <h3 className="text-blue text-xl font-semibold hellix-font mb-4">
              There are two types of Working Holiday Visas:
            </h3>
            <div className="space-y-4">
              <div className="p-4 bg-green-50 rounded-lg">
                <h4 className="text-blue font-semibold hellix-font mb-2">1. Subclass 417</h4>
                <p className="text-blue text-sm hellix-font">For passport holders of UK, Canada, France, Germany, Ireland, Italy, Japan, South Korea, and more.</p>
              </div>
              <div className="p-4 bg-blue-50 rounded-lg">
                <h4 className="text-blue font-semibold hellix-font mb-2">2. Subclass 462</h4>
                <p className="text-blue text-sm hellix-font">For passport holders of USA, Spain, Chile, Indonesia, Thailand, Malaysia, and more.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Eligibility Requirements */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            Eligibility Requirements
          </h1>
        </div>

        <div className="mt-8">
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <h3 className="text-blue text-xl font-semibold hellix-font mb-6">
              To qualify for a Working Holiday Visa, you must:
            </h3>
            <div className="space-y-4">
              {[
                { icon: FaCalendarAlt, text: "Be aged 18-35 (or 18-30 for some countries under Subclass 462)" },
                { icon: FaPassport, text: "Hold a passport from an eligible country" },
                { icon: FaDollarSign, text: "Have sufficient funds (usually AUD $5,000+) to support your stay" },
                { icon: FaUserCheck, text: "Meet health & character requirements" },
                { icon: FaCheckCircle, text: "Not have previously entered Australia on this visa (unless applying for a second or third year)" }
              ].map((requirement, index) => {
                const IconComponent = requirement.icon;
                return (
                  <div key={index} className="flex items-start gap-3 p-4 bg-green-50 rounded-lg">
                    <FaCheckCircle className="text-green-500 text-lg mt-1 flex-shrink-0" />
                    <span className="text-blue hellix-font">{requirement.text}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* How Long Can You Stay */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            How Long Can You Stay?
          </h1>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white shadow-custom-white rounded-lg p-6 text-center">
            <div className="flex justify-center mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">1st</span>
              </div>
            </div>
            <h3 className="text-blue text-xl font-semibold hellix-font mb-3">First WHV</h3>
            <p className="text-blue hellix-font">Up to 12 months</p>
          </div>

          <div className="bg-white shadow-custom-white rounded-lg p-6 text-center">
            <div className="flex justify-center mb-4">
              <div className="bg-green-600 text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">2nd</span>
              </div>
            </div>
            <h3 className="text-blue text-xl font-semibold hellix-font mb-3">Second WHV</h3>
            <p className="text-blue hellix-font text-sm">Eligible after completing 3-6 months of specified work (e.g., farming, tourism, construction)</p>
          </div>

          <div className="bg-white shadow-custom-white rounded-lg p-6 text-center">
            <div className="flex justify-center mb-4">
              <div className="bg-purple-600 text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">3rd</span>
              </div>
            </div>
            <h3 className="text-blue text-xl font-semibold hellix-font mb-3">Third WHV</h3>
            <p className="text-blue hellix-font text-sm">(Subclass 417 only): Available for those who complete additional regional work</p>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Work & Travel Opportunities */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            Work & Travel Opportunities
          </h1>
        </div>

        <div className="mt-8">
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <h3 className="text-blue text-xl font-semibold hellix-font mb-6">
              With a Working Holiday Visa, you can:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                { icon: FaGlobe, text: "Travel across Australia's stunning landscapes" },
                { icon: FaBriefcase, text: "Take up short-term jobs (hospitality, farming, retail, etc.)" },
                { icon: FaGraduationCap, text: "Gain international work experience" },
                { icon: FaCalendarAlt, text: "Extend your stay by applying for a Second or Third-Year Visa" }
              ].map((opportunity, index) => {
                const IconComponent = opportunity.icon;
                return (
                  <div key={index} className="flex items-start gap-3 p-4 bg-yellow-50 rounded-lg">
                    <IconComponent className="text-blue text-2xl mt-1 flex-shrink-0" />
                    <span className="text-blue hellix-font font-medium">{opportunity.text}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* How to Apply */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            How to Apply for a Working Holiday Visa
          </h1>
        </div>
        
        <div className="mt-6 space-y-6">
          {/* Step 1 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">1</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Check Eligibility
              </h3>
            </div>
            <div className="ml-16">
              <p className="text-blue hellix-font">Confirm your country is on the approved list.</p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">2</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Gather Documents
              </h3>
            </div>
            <div className="ml-16">
              <p className="text-blue hellix-font">Passport, proof of funds, health insurance, etc.</p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">3</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Apply Online
              </h3>
            </div>
            <div className="ml-16">
              <p className="text-blue hellix-font">Submit your application via the Australian Home Affairs website.</p>
            </div>
          </div>

          {/* Step 4 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">4</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Wait for Approval
              </h3>
            </div>
            <div className="ml-16">
              <p className="text-blue hellix-font">Processing times vary (usually weeks to a few months).</p>
            </div>
          </div>

          {/* Step 5 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">5</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Travel & Work
              </h3>
            </div>
            <div className="ml-16">
              <p className="text-blue hellix-font">Once approved, you can enter Australia within 12 months.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Why Choose Us */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            Why Choose Immiget Global?
          </h1>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { 
              icon: FaUsers, 
              title: "Expert Guidance", 
              text: "We simplify the visa process for you." 
            },
            { 
              icon: FaCheckCircle, 
              title: "High Success Rate", 
              text: "Our team ensures accurate applications." 
            },
            { 
              icon: FaHeart, 
              title: "Post-Arrival Support", 
              text: "Get tips on jobs, accommodation, and travel in Australia." 
            }
          ].map((service, index) => {
            const IconComponent = service.icon;
            return (
              <div key={index} className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
                <div>
                  <IconComponent className="text-blue text-4xl" />
                </div>
                <div className="text-center">
                  <h3 className="text-blue text-xl font-semibold hellix-font mb-2">{service.title}</h3>
                  <p className="text-blue text-sm hellix-font">{service.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* CTA Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-lg p-8 text-center">
          <h2 className="text-2xl text-blue font-bold hellix-font mb-4">
            Start Your Australian Adventure Today!
          </h2>
          <p className="text-blue text-lg hellix-font mb-6">
            📞 Contact Immiget Global for a free consultation and take the first step toward your working holiday in Australia!
          </p>
          <button 
            onClick={scrollToContact}
            className="px-8 py-3 bg-blue text-white font-semibold hellix-font rounded-lg hover:bg-blue-700 transition-colors"
          >
            Get Free Consultation
          </button>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* FAQs */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            FAQs
          </h1>
        </div>

        <div className="mt-8 space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white shadow-custom-white rounded-lg overflow-hidden">
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none"
              >
                <h3 className="text-blue font-semibold hellix-font text-lg">
                  ❓ {faq.question}
                </h3>
                {activeIndex === index ? (
                  <FaTimes className="text-blue text-lg" />
                ) : (
                  <FaPlus className="text-blue text-lg" />
                )}
              </button>
              {activeIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-blue hellix-font">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Testimonials */}
      <div className="py-6 xl:py-10">
        <Testimonials testimonials={testimonials} title="Testimonials" />
      </div>

      {/* How We Help Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex max-lg:flex-col justify-between gap-6 lg:gap-[80px] lg:items-center">
          <div className="lg:w-[50%]">
            <div className="flex gap-2">
              <div className="flex items-center">
                <img src={helpIcon} alt="help" />
              </div>
              <h1 className="text-[26px] text-blue font-semibold hellix-font">
                How Immiget Global Can Help
              </h1>
            </div>
            <p className="hellix-font text-blue text-lg font-normal mt-4">
              Our experienced team specializes in Working Holiday Visa applications and understands the unique requirements for each country. We provide comprehensive guidance from eligibility assessment to post-arrival support, ensuring your Australian adventure starts smoothly and successfully.
            </p>
            <div className="flex gap-4 mt-6">
              <button 
                onClick={scrollToContact}
                className="px-6 py-3 bg-blue text-white font-semibold hellix-font rounded-lg hover:bg-blue-700 transition-colors"
              >
                Contact Us Today
              </button>
            </div>
          </div>
          <div className="lg:w-[50%] max-lg:justify-center max-lg:flex">
            <img src={helpImage} alt="How we can help" />
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div id="contact-section">
        <Contact />
      </div>
    </div>
  );
};

export default WorkingHolidayVisa;